// Mint-Home · N-04f: Việc của team (vai sale) — dữ liệu mẫu theo code board (DK_TEAM / DK_PPOOL).
// [người, ghế, mở, quá hạn, chờ bên ngoài, % đúng hạn 30 ngày, cổng 0|1|2]
export interface TeamRow { k: string; seat: string; open: number; over: number; wait: number; ont: number; gate: 0 | 1 | 2 }
export const TEAM_SALE: readonly TeamRow[] = [
  { k: 'TUANNT', seat: '[SALE-SE] Sale · đang nghỉ (DAVID thay)', open: 7, over: 0, wait: 1, ont: 92, gate: 0 },
  { k: 'ANDG', seat: '[SALE-SE] Sale', open: 9, over: 1, wait: 2, ont: 88, gate: 0 },
  { k: 'TRANG', seat: '[SALE-PRC] Pricing', open: 12, over: 2, wait: 1, ont: 81, gate: 1 },
  { k: 'MAITTN', seat: '[CSD-CSO] CS', open: 14, over: 1, wait: 6, ont: 79, gate: 0 },
  { k: 'HOATTN', seat: '[CSD-CSO] CS', open: 11, over: 0, wait: 1, ont: 95, gate: 0 },
  { k: 'ThuyNTT', seat: '[CSD-CSO] CS', open: 10, over: 3, wait: 2, ont: 72, gate: 2 },
];
// việc minh hoạ của từng người: [code, việc, đối tượng, hạn, tone]
export type PTone = 'tx' | 'warn' | 'err';
export const PPOOL_SALE: readonly (readonly [string, string, string, string, PTone])[] = [
  ['PRC', 'Báo giá VNSGN → CNXMN 1×40HC', 'PR-261021-0946219', 'Ngày mai 10:00', 'tx'],
  ['DCF', 'Debit chờ khách xác nhận', 'DN26054051', 'Còn 6h', 'tx'],
  ['FBL', 'Gửi Final B/L', 'SE260636900', 'Quá 1h', 'err'],
  ['VCN', 'Báo khách đổi tàu', 'SE260636780', 'Còn 1h 45′', 'warn'],
  ['PSI', 'Nộp SI trước CloseDoc', 'SE260622020', 'Còn 5h', 'tx'],
];
